import axios from 'axios';

export const projectService = {
    async getAllActiveServiceCategories() {
        const response = await axios.get("api/servicecategory/getallactive");
        return response.data.data;
    },

    async createProject(projectData) {
        const response = await axios.post("api/homeproject/addproject", projectData);
        return response.data;
    },

    async uploadProjectFiles(projectId, verificationId, files) {
        const formData = new FormData();
        formData.append("projectId", parseInt(projectId));
        formData.append("verificationId", verificationId);
        
        for (const file of files) {
            formData.append("files", file);
        }

        const requestHeaders = {
            "Content-Type": "multipart/form-data"
        };

        const response = await axios.post("api/homeproject/addfilestoproject", formData, { 
            headers: requestHeaders 
        });
        
        return response.data;
    },

    buildProjectRequest(serviceState, providerState, formData, answers, language) {
        return {
            ServiceId: serviceState.selectedServiceId,
            PostalAreaId: providerState.postalArea?.id,
            ProviderId: providerState.checkProvider?.id || null,

            CustomerIsAxaCustomer: formData.customerIsAxaCustomer === "true" || formData.customerIsAxaCustomer === true,
            CustomerLastName: formData.customerLastName,
            CustomerName: formData.customerFirstName,
            CustomerGSM: formData.customerGsmNumber,
            CustomerEmail: formData.customerEmail,
            CustomerDescription: formData.customerDescription,
            CustomerStreetHouseNumber: formData.customerAddressStreetAndHouse,
            CustomerBus: formData.customerAddressBusStation,
            CustomerPrivacyAccepted: formData.customerPrivacyAccepted,
            CustomerPrivacyMarketing: formData.customerPrivacyMarketing,
            CustomerLanguage: language,

            Answers: answers
        };
    }
};
